{
	"titleFirstPart": "Welkom bij",
	"titleSecondPart": "Heidelberg Materials {{productName}}",
	"totalCarbonStored": "Totaal opgeslagen koolstof"
}
